// extracted by mini-css-extract-plugin
export default {"pageContainer":"codePage_pageContainer__pw1xq"};